module.exports = __webpack_public_path__ + "img/dados-conta.cafee94f.png";